export const SEPARATORS = [
  { label: 'Semicolon (;)', value: ';' },
  { label: 'Comma (,)', value: ',' },
  { label: 'Tab (\\t)', value: '\\t' },
];

export const FORMATS = [
  'UTF-8',
  'UTF-16',
  'WINDOWS-1250',
  'WINDOWS-1252',
  'WINDOWS-1253',
  'WINDOWS-1254',
  'WINDOWS-1255',
  'WINDOWS-1256',
  'MS-ANSI',
  'UNICODE',
];
